module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetHigh@2x.d5749d0.jpg";